// @flow strict

import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'
import { subtitleNodeName } from '@mondough/contentful/src/richTextDecorators'
import { defaultSubtitleSection } from '../defaultThemeComponents'
import ECBRates from '../../components/bespoke/ECBRates'

// ECB = European Central Bank
export const renderECBRates = (node: ContentfulNode) => {
  return (
    <ECBRates>
      {node[subtitleNodeName] && defaultSubtitleSection(node[subtitleNodeName])}
    </ECBRates>
  )
}
